import React from 'react';

import { Modal, ModalHeader, ModalBody, ModalFooter } from 'Components/Modal';
import { PrimaryButton, SecondaryButton } from 'Components/Button';

import MeApi from 'Services/Api/Me/Me';
import {dateTimeToTwelveHour} from 'Services/DateHelpers';

class OfferPopUp extends React.Component {
    state = {
        working: false,
        error: null,
    };

    /**
     * Call the API to accept or decline the offer, then close the modal.
     */
    respond = async (action) => {
        this.setState({ working: true, error: null });

        const response = await MeApi.respondToAttendanceOffer({ action });

        if (response?.status === 200) {
            this.props.onClose();
        } else {
            this.setState({
                working: false,
                error: 'Something went wrong. Please try again.',
            });
        }
    };

    handleAccept  = () => this.respond('accept');
    handleDecline = () => this.respond('decline');

    render() {
        const { working, error } = this.state;
        const { offer } = this.props;

        // Format the expiry time if available.
        const expiresAt = offer?.expires_at
            ? (typeof offer.expires_at === 'object'
                ? dateTimeToTwelveHour(offer.expires_at.date_time_timezone ?? offer.expires_at.iso_string)
                : dateTimeToTwelveHour(offer.expires_at))
            : null;

        return (
            <Modal size="max-w-lg">
                <ModalHeader>
                    🎉 You have a seat offer!
                </ModalHeader>

                <ModalBody>
                    <div className="text-center space-y-4">
                        <p className="text-gray-700 text-base">
                            A place has become available at the Bupa Symposium 2026 in-person event.
                            Would you like to accept this offer and attend in person?
                        </p>
                        {expiresAt && (
                            <p className="text-gray-500 text-sm">
                                This offer expires at <strong>{expiresAt}</strong>.
                            </p>
                        )}
                        {error && (
                            <p className="text-red-500 text-sm">{error}</p>
                        )}
                    </div>
                </ModalBody>

                <ModalFooter alignment="center">
                    <SecondaryButton
                        onClick={this.handleDecline}
                        text="Decline"
                        working={working}
                    />
                    <PrimaryButton
                        onClick={this.handleAccept}
                        text="Accept Offer"
                        working={working}
                    />
                </ModalFooter>
            </Modal>
        );
    }
}

export default OfferPopUp;
